import { render, staticRenderFns } from "./RegistrationDays.vue?vue&type=template&id=9fc842c0&scoped=true&"
import script from "./RegistrationDays.vue?vue&type=script&lang=js&"
export * from "./RegistrationDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc842c0",
  null
  
)

export default component.exports